import { LOCALE_ID } from '@angular/core';

export const localeProvider = {provide: LOCALE_ID, useValue: 'cs'};
